import { useTranslation } from "react-i18next";
import Label, { statusText } from ".";
import { useRecordContext } from "react-admin";
/* if (kytPayload.rating === 'highRisk' || kytPayload.rating === 'critical') return false;
 */export const mapStatus = {
  UNKNOWN: {
    state: "success",
    text: "No risk",
    original: "No risk",
  },
  HIGHRISK: {
    state: "error",
    text: "With risk",
    original: "With risk",
  },
  CRITICAL: {
    state: "error",
    text: "With risk",
    original: "With risk",
  },
  LOWRISK: {
    state: "success",
    text: "No risk",
    original: "No risk",
  },
};
// A rating the admin does not know is shown as such, never as a verdict.
const UNRATED = { state: "info", text: "Not rated", original: "Not rated" };
export const KytLabel = ({
  fontSize = "normal",
  statusField = "rating",
  record: propRecord = null,
}) => {
  const { t }: { t: any } = useTranslation();
  const recordContext = useRecordContext();
  const record = propRecord || recordContext;
  
  // Si record n'existe pas, afficher un état par défaut sans modifier record
  const status = record?.[statusField]?.toUpperCase() || "ERROR";
  const statusInfo = mapStatus[status] || UNRATED;
  const { text, state } = statusInfo;
  
  return (
    <Label color={state}>
      {t(statusText(text))}
    </Label>
  );
};

